export default __webpack_public_path__ + "static/media/8.66812846.jpg";